var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Script properties")]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: { label: "Name", fancy: "" },
                    model: {
                      value: _vm.script.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.script, "Name", $$v)
                      },
                      expression: "script.Name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.scriptTypes,
                      label: "Script Type",
                      fancy: "",
                    },
                    model: {
                      value: _vm.script.ScriptType,
                      callback: function ($$v) {
                        _vm.$set(_vm.script, "ScriptType", $$v)
                      },
                      expression: "script.ScriptType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: "Icon" },
                    model: {
                      value: _vm.script.Icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.script, "Icon", $$v)
                      },
                      expression: "script.Icon",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      attrs: {
                        target: "_blank",
                        to: "https://fontawesome.com/v5/search",
                      },
                    },
                    [_vm._v("Lijst met icons")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "", center: "" } },
                    [
                      _c(
                        "h4",
                        [
                          _vm._v(" Standard args "),
                          _c(
                            "w-link",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.standardArgTooltip,
                                  expression: "standardArgTooltip",
                                },
                              ],
                            },
                            [
                              _c("w-fa", {
                                attrs: { icon: "question-circle" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-spacer"),
                      _c(
                        "div",
                        [
                          _c(
                            "w-button",
                            {
                              attrs: { flat: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.addStandardArg()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "plus" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.script.StandardArgs, function (standardArg, i) {
            return _c(
              "w-row",
              { key: i },
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [
                    _c(
                      "w-row",
                      { attrs: { "no-margin": "" } },
                      [
                        _c("w-input", {
                          staticClass: "grow mr",
                          attrs: { label: "Name", fancy: "" },
                          model: {
                            value: standardArg.Name,
                            callback: function ($$v) {
                              _vm.$set(standardArg, "Name", $$v)
                            },
                            expression: "standardArg.Name",
                          },
                        }),
                        _c("w-select", {
                          staticClass: "grow mr",
                          attrs: {
                            items: _vm.standardArgTypeItems,
                            label: "Type",
                            fancy: "",
                          },
                          model: {
                            value: standardArg.Type,
                            callback: function ($$v) {
                              _vm.$set(standardArg, "Type", $$v)
                            },
                            expression: "standardArg.Type",
                          },
                        }),
                        _c(
                          "w-button",
                          {
                            attrs: { flat: "" },
                            on: {
                              click: function ($event) {
                                return _vm.removeStandardArg(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                standardArg.Type == "table-structure"
                  ? _c("app-structure-edit", {
                      model: {
                        value: standardArg.Value,
                        callback: function ($$v) {
                          _vm.$set(standardArg, "Value", $$v)
                        },
                        expression: "standardArg.Value",
                      },
                    })
                  : _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-textarea", {
                          attrs: { label: "Value", fancy: "" },
                          model: {
                            value: standardArg.Value,
                            callback: function ($$v) {
                              _vm.$set(standardArg, "Value", $$v)
                            },
                            expression: "standardArg.Value",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            )
          }),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "", center: "" } },
                    [
                      _c(
                        "h4",
                        [
                          _vm._v(" Extra args "),
                          _c(
                            "w-link",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.extraArgTooltip,
                                  expression: "extraArgTooltip",
                                },
                              ],
                            },
                            [
                              _c("w-fa", {
                                attrs: { icon: "question-circle" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-spacer"),
                      _c(
                        "div",
                        [
                          _c(
                            "w-button",
                            {
                              attrs: { flat: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.addExtraArg()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "plus" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.script.ExtraArgs, function (extraArg, i) {
            return _c(
              "w-row",
              { key: `e${i}` },
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "6" } },
                  [
                    _c("w-input", {
                      staticClass: "grow",
                      attrs: { label: "Name", fancy: "" },
                      model: {
                        value: extraArg.Name,
                        callback: function ($$v) {
                          _vm.$set(extraArg, "Name", $$v)
                        },
                        expression: "extraArg.Name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "6" } },
                  [
                    _c(
                      "w-row",
                      { attrs: { "no-margin": "" } },
                      [
                        _c("w-select", {
                          staticClass: "grow",
                          attrs: {
                            label: "Type",
                            items: _vm.extraArgTypeItems,
                            fancy: "",
                          },
                          model: {
                            value: extraArg.Type,
                            callback: function ($$v) {
                              _vm.$set(extraArg, "Type", $$v)
                            },
                            expression: "extraArg.Type",
                          },
                        }),
                        _c(
                          "w-button",
                          {
                            attrs: { flat: "" },
                            on: {
                              click: function ($event) {
                                return _vm.removeExtraArg(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                extraArg.Type == "number"
                  ? _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input-number", {
                          attrs: { label: "Decimalen", fancy: "", decimals: 0 },
                          model: {
                            value: extraArg.Decimals,
                            callback: function ($$v) {
                              _vm.$set(extraArg, "Decimals", $$v)
                            },
                            expression: "extraArg.Decimals",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-col",
                  { attrs: { xs: "12", "no-margin": "" } },
                  [
                    _c("app-translation-edit", {
                      model: {
                        value: extraArg.FriendlyName,
                        callback: function ($$v) {
                          _vm.$set(extraArg, "FriendlyName", $$v)
                        },
                        expression: "extraArg.FriendlyName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" Close ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }